import axios from 'axios';
import { Dispatch } from 'redux';
import {
    CLEAR_SYNC_GUEST_CARD_MESSAGE, SYNC_GUEST_CARD_FAILURE,
    SYNC_GUEST_CARD_REQUEST,
    SYNC_GUEST_CARD_SUCCESS
} from '../constants/syncGuestCard';

const syncGuestCardRequest = () => {
    return {
        type: SYNC_GUEST_CARD_REQUEST,
    };
};

const syncGuestCardSuccess = (data: any) => {
    return {
        type: SYNC_GUEST_CARD_SUCCESS,
        payload: data,
    };
};

const syncGuestCardFailure = (error: any) => {
    return {
        type: SYNC_GUEST_CARD_FAILURE,
        payload: error,
    };
};

const clearSyncGuestCardMessageAction = () => {
    return {
        type: CLEAR_SYNC_GUEST_CARD_MESSAGE,
    };
};

export const syncGuestCard = (syncGuestCardObj: any, page: number, limit: number, searchText: string) => {
    return async (dispatch: Dispatch<any>) => {
        dispatch(syncGuestCardRequest());
        await axios
            .patch('/realpage/sync-guestCard', syncGuestCardObj)
            .then((response) => {
                dispatch(syncGuestCardSuccess(response.data));
            })
            .catch((err) => dispatch(syncGuestCardFailure(err)));
    };
};

export const clearSyncGuestCardMessage = () => {
    return (dispatch: Dispatch) => {
        dispatch(clearSyncGuestCardMessageAction());
    };
};
